import { sdk } from '@/sdk';

export async function getAccount() {
  // @ts-expect-error
  const { data } = await sdk.composableCommerce.account.getAccount();
  return data.account;
}
